import * as styles from "./TromanDatePicker.module.less";
import DatePicker, { ReactDatePickerCustomHeaderProps, registerLocale } from  "react-datepicker";
import { sv } from 'date-fns/locale/sv';
import { Icon, Icons } from "../Buttons";
import _ from "lodash";
import { useCallback, useRef, useState } from "react";
import { DropdownOption, DropdownSelect } from "./DropdownSelect";

registerLocale('sv', sv);

const monthOptions = _.range(0, 12).map(x => ({ text: sv.localize.month(x as any).replace(/^./, x => x.toUpperCase()), value: x }));
function getYearOptions(center: number) {
    return _.range(center-5, center+6).map(x => ({ text: x.toString(), value: x }));
}

function CustomHeader(props: ReactDatePickerCustomHeaderProps) {
    const fullYear = props.monthDate.getFullYear();
    const [yearOptions, setYearOptions] = useState(() => getYearOptions(fullYear));
    const handleScroll = useCallback((step: number) => setYearOptions(getYearOptions(yearOptions[5].value + step)), [yearOptions, setYearOptions]);

    const selectedMonth = monthOptions[props.monthDate.getMonth()];
    const selectedYear: DropdownOption<number> = { text: fullYear.toString(), value: fullYear };

    return (
        <div className={styles.header}>
            <button className={styles.prev} onClick={props.decreaseMonth}><Icon icon={Icons.ChevronLeft}/></button>
            <DropdownSelect className={styles.selectMonth} options={monthOptions} selected={selectedMonth} select={props.changeMonth}/>
            <DropdownSelect
                    className={styles.selectYear}
                    options={yearOptions}
                    selected={selectedYear}
                    select={props.changeYear}
                    scroll={handleScroll}/>
            <button className={styles.next} onClick={props.increaseMonth}><Icon icon={Icons.ChevronRight}/></button>
        </div>
    )
}

function renderCustomHeader(props: ReactDatePickerCustomHeaderProps) {
    return (<CustomHeader {...props}/>);
}

export interface ITromanDatePickerProps {
    date: Date|null;
    minDate?: Date;
    maxDate?: Date;
    disabled?: boolean;
    isClearable?: boolean;
    onChange: (dt: Date|null) => void;
}

export const TromanDatePicker = (props: ITromanDatePickerProps) => {
    const ref = useRef<DatePicker>(null);
    return (
        <DatePicker
            ref={ref}
            minDate={props.minDate}
            maxDate={props.maxDate}
            disabled={props.disabled}
            selected={props.date}
            onChange={props.onChange}
            onBlur={() => ref.current?.setState({inputValue: null})}
            dateFormat="yyyy-MM-dd"
            locale="sv"
            popperClassName={styles.tromanDatepicker}
            customInput={<input className="form-control input-sm" />}
            todayButton={"Idag"}
            renderCustomHeader={renderCustomHeader}>
            {
                props.isClearable === false ? undefined : (<button className={styles.clear} onClick={() => { ref.current?.clear(); ref.current?.setOpen(false); }}>Rensa</button>)
            }
        </DatePicker>
    )
}